<template>
	<div id="content">
		<div class="wrapper">
			<h1>Vielen Dank für Ihr Feedback!</h1>
			<p v-if="satisfied">
				Wir würden uns sehr über eine kurze Rezension auf unserem
				<a href="https://www.google.de/maps/place/CarMarkt+(Fa.+Purushotham)/@51.4532032,6.8597164,15z/data=!4m5!3m4!1s0x0:0x83f3e9b09ac6ecd3!8m2!3d51.4532032!4d6.8597164#">Google Profil</a>
				freuen. Vielen Dank!
			</p>
			<p v-else>
				Schade, dass Sie mit Ihrem Besuch nicht zufrieden waren. Wir würden gerne erfahren, was wir besser machen können - Sie können uns jederzeit über
				das <router-link to="/contact">Kontaktformular</router-link> oder telefonisch erreichen.
			</p>
		</div>
		<transition>
			<div v-show="loading" class="loading-wrapper">
				<div class="lds-ring"><div></div><div></div><div></div><div></div></div>
			</div>
		</transition>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'SatisfactionReport',
	data() {
		const { option, invoiceId } = this.$route.query
		return {
			loading: true,
			satisfied: option === 'yes',
			invoiceId,
		}
	},
	mounted() {
		axios.post(`https://api.carmarkt.net/invoices/${this.invoiceId}/customer-feedback`, {
			satisfied: this.satisfied,
		}).finally(() => {
			this.loading = false
		})
	}
}
</script>

<style lang="scss" scoped>
.loading-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	background-color: rgba(255, 255, 255, 0.5);
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}
</style>
